/**
 * SplitReceiptButton Component
 * 
 * A split button that provides quick access to receipt generation:
 * - Primary action: Generate single receipt immediately
 * - Dropdown menu: Access advanced split methods (Partes Iguales, Personalizado)
 * 
 * Used in restaurant table/group contexts to streamline the receipt creation flow.
 */

import React, { useState } from 'react';
import { Button, Dropdown, ButtonGroup } from 'react-bootstrap';
import { FaReceipt, FaChevronDown } from 'react-icons/fa6';
import './SplitReceiptButton.scss';

interface SplitReceiptButtonProps {
  onGenerateSingle: () => void;
  onShowSplitOptions: (method: 'equal' | 'custom') => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
  className?: string;
}

const SplitReceiptButton: React.FC<SplitReceiptButtonProps> = ({
  onGenerateSingle,
  onShowSplitOptions,
  disabled = false,
  variant = 'primary',
  className = ''
}) => {
  const handleDropdownSelect = (method: 'equal' | 'custom') => {
    onShowSplitOptions(method);
  };

  const baseClassName = variant === 'primary' 
    ? 'footer-cta-button footer-cta-secondary' 
    : 'footer-cta-button footer-cta-secondary';

  return (
    <Dropdown as={ButtonGroup} drop="up" className={`split-receipt-button-wrapper ${className}`}>
      <Button
        className={`${baseClassName} split-receipt-main-btn`}
        onClick={onGenerateSingle}
        variant="none"
        disabled={disabled}
      >
        <FaReceipt /> Generar Precuenta
      </Button>
      
      <Dropdown.Toggle
        split
        className={`${baseClassName} split-receipt-dropdown-toggle`}
        variant="none"
        disabled={disabled}
      >
        <FaChevronDown />
      </Dropdown.Toggle>

      <Dropdown.Menu className="split-receipt-dropdown-menu">
        <Dropdown.Item
          onClick={() => handleDropdownSelect('equal')}
          className="split-receipt-dropdown-item"
        >
          Dividir en Partes Iguales
        </Dropdown.Item>
        <Dropdown.Item
          onClick={() => handleDropdownSelect('custom')}
          className="split-receipt-dropdown-item"
        >
          Dividir Personalizado
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SplitReceiptButton;
